import { type FunctionComponent } from "react";
import type { SelectionHintProps } from "./props";

import styles from "./SelectionHint.web.css";

export const SelectionHint: FunctionComponent<SelectionHintProps> = ({ hintMessage, children }) => {
  if (!hintMessage) return <>{children}</>;

  return (
    <section className={styles.selectionHint}>
      <span className={styles.hintIndicator} aria-hidden="true" />
      <div className={styles.selectionHintContent}>
        <span className={styles.hintMessage}>{hintMessage}</span>
        {children != null && <div className={styles.groupedSelections}>{children}</div>}
      </div>
    </section>
  );
};
